import BaseType from "./BaseType";

export default class Schwebetuer extends BaseType(THREE.Group) {

    constructor(vsData) {
        super(vsData);
    }

}

